import { generatePath } from "@routes/utils";

import type { IExtractParams } from "@routes";

const pathBase = `/geo/states/`;
const pathById = `${pathBase}:stateId/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;
export type IPathByIdParam = IExtractParams<typeof pathById>;

export const states = {
  getAll: (param: IPathBaseParam) => generatePath(pathBase, param),
  get: (param: IPathByIdParam) => generatePath(pathById, param),
} as const;
